

(function ($) {

	const app = {
		windowHeight: $(window).height(),
		windowWidth: $(window).width(),
		isMobile: false,
		isTabletPortrait: false,
		isTouch: false,
		resizeTimeoutID: null,
		$body: $('body'),
		culture: 'en',
		isIe: false,
		responsiveBreakpointValue: '(max-width: 1200px)',
		responsiveBreakpointBoolean: false,
		hamburgerBoolean: false,
		hamburgerBoolean2: false,
		successSwiper: false,
		isScrolling: false,
		disableSpotlightScroll: false,
		headerHeight: $('.header').height(),
		categorySwiper: null,
		//	gallerySlider: '',
		detectDevice() {



			(function (a) {
				if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
					app.isMobile = true;
				}
			}(navigator.userAgent || navigator.vendor || window.opera));
			if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {

				app.$body.addClass('touch');
			} else {
				app.$body.addClass('no-touch');
			}

			if (app.windowWidth <= 992) {
				app.isTabletPortrait = true
				app.disableSpotlightScroll = true
			}
		},
		getMobileOperatingSystem() {
			var userAgent = navigator.userAgent || navigator.vendor || window.opera;



			if (/android/i.test(userAgent)) {

				app.$body.addClass('android-device');
				app.isTouch = true;
			}

			// iOS detection from: http://stackoverflow.com/a/9039885/177710
			if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
				app.$body.addClass('ios-device');
				app.isTouch = true;
			}
			let isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
				(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
			if (isIOS) {
				app.$body.addClass('ios-device');
				app.isTouch = true;
			}


		},
		detectCulture() {
			if ($('html').attr('lang') === 'ar') {
				app.culture = 'ar';
			}
		},
		windowResize() {
			app.windowHeight = $(window).height();
			app.windowWidth = $(window).width();

		},
		resizeListner() {
			if (!app.isMobile) {
				$(window).resize(() => {
					clearTimeout(app.resizeTimeoutID);
					app.resizeTimeoutID = setTimeout(app.windowResize, 500);
				});
			} else {
				window.addEventListener('orientationchange', () => {
					app.windowResize();
				});
			}
		},


		addEventListner() {

			var readMore = $('.identity__cta .btn').text();

			$('.identity__cta .btn').click(function (e) {
				e.preventDefault();
				$('.identity__hidden').toggle()

				if ($(this).text() === readMore) {

					$(this).text($(this).attr('data-less'))
				}
				else {
					$(this).text(readMore)
				}
			})


			// $('.register-btn').click(function (e) {
			// 	e.preventDefault();
			// 	$('form.row,.register-details').hide();
			// 	$('.enquiry-form__msg').show()
			// })




			$('a').click(function (e) {
				var href = $(this).attr("href");
				var hash = href.substr(href.indexOf("#"));
				if (hash.length > 1) {
					$('html').removeClass('overflow-hidden');
					app.disableSpotlightScroll = true;
				}
			})



			$('.faq .video-overlay__close').click(function () {
				$('.faq .video-overlay').hide()
				$('.faq .video-overlay video').get(0).pause()
			})
			$('.faq__video img').click(function (e) {
				$('.faq .video-overlay').css('display', 'flex')
				$('.faq .video-overlay video').attr('src', $(this).attr('data-video'));
				$('.faq .video-overlay video').get(0).play()
			});

			//$('.home-spotlight .swiper .swiper-slide').width($('.spotlight__col').width())


			var length = $('.form .form-input__textarea').attr('maxlength')
			$('.form .char-text').html($('.form .char-text').text().replace('{count}', `<span>${length}</span>`))

			$('.form .form-input__textarea').on("input", function () {


				var currentLength = $(this).val().length;
				$('.form .char-text span').text(length - currentLength)


			});

		},

		tabs: function () {
			// global tabing
			var limit = $('#ItemsLimit').val();
			var counter = 1


			if ($(`.category .swiper-slide a[href='${window.location.hash}']`).length != 0) {

				var index = $(`.category .swiper-slide a[href='${window.location.hash}']`).parents('.swiper-slide').index()
				$(`.category .swiper-slide a[href='${window.location.hash}']`).addClass('active')
				$(".tab-pane").eq(index).addClass('show')
				$(".benefit-features .app-details__app").eq(index).addClass('show')
				app.categorySwiper.slideTo(index)

			} else {
				$(`.app-details__copy,.faq__content`).each(function () {
					$(this).find('.swiper-slide a').eq(0).addClass('active')
					$(this).find('.tab-pane').eq(0).addClass('show')


				})
				// $(".benefit-features .app-details__app").eq(0).addClass('show')
				// $(`.category .swiper-slide a`).eq(0).addClass('active')
				// $(".tab-pane").eq(0).addClass('show')
				$(".benefit-features .app-details__app").eq(0).addClass('show')
			}
			showHideFaq();
			$(".category .swiper-slide a").click(function (event) {


				var index = $(this).parents('.swiper-slide').index()
				counter = 1

				//event.preventDefault();
				$(this).parents('.app-details__copy,.faq__content').find(".category .swiper-slide a").removeClass("active");
				$(this).addClass("active");
				// var tab = $(this).attr("href");
				$(this).parents('.app-details__copy,.faq__content').find(".tab-pane").removeClass('show');



				$(this).parents('.app-details__copy,.faq__content').find(".tab-pane").eq(index).addClass("show");
				$(".benefit-features .app-details__app").removeClass('show')
				$(".benefit-features .app-details__app").eq(index).addClass('show')

				//$(tab).siblings().removeClass("show");
				$('.accordion__inner').hide()
				//$('html,body').stop().animate({ scrollTop: $(".tab-pane.show").parents(".app-details__col").offset().top - app.headerHeight }, 200);


				//console.log(index)
				app.categorySwiper.slideTo(index)
				showHideFaq()
			});

			function showHideFaq() {

				$('.tab-pane.show').find('.accordion__inner').slice(0, limit).show()
				showHideButton(limit);
			}



			$('#faq-view').click(function () {
				counter += 1;
				////console.log(limit * counter)
				$('.tab-pane.show').find('.accordion__inner').slice(limit, limit * counter).show()
				showHideButton(limit * counter);
			})
			function showHideButton(items) {
				if ($('.tab-pane.show').find('.accordion__inner').length > items) {
					$('#faq-view').show()
				}
				else {
					$('#faq-view').hide()
				}
			}
		},
		accordion: function () {

			$('.accordion__inner').click(function () {
				var media = $(this).find('.accordion__media');

				if (media.length === 1) {
					var image = media.find('img')
					var video = media.find('video')
					var iframe = media.find('iframe')
					if (image.length === 1) {
						//console.log("has image");

						$('.faq__image--default,.faq__video,.faq__iframe').hide()
						$('.faq__image--dynamic').show().find('img').attr('src', image.attr('data-src'))
						$('.faq__iframe iframe').attr('src', '')
					}
					else if (video.length === 1) {
						//console.log("has video");

						$('.faq__image--default,.faq__image--dynamic,.faq__iframe').hide()
						$('.faq__video').show().find('img').attr('src', video.attr('poster')).attr('data-video', video.attr('src'))
						$('.faq__iframe iframe').attr('src', '')

					}
					else {
						//console.log("has iframe");

						$('.faq__image--default,.faq__image--dynamic,.faq__video').hide()
						$('.faq__iframe').show().find("iframe").attr('src', iframe.attr('data-src'));

					}


				}
				else {
					$('.faq__image--dynamic,.faq__video,.faq__iframe').hide()
					$('.faq__iframe iframe').attr('src', '')
					$('.faq__image--default').show()
				}

				$('.accordion__content').slideUp()
				if ($(this).hasClass('accordion__inner--active')) {
					$(this).removeClass('accordion__inner--active')

				}
				else {
					$('.accordion__inner').removeClass('accordion__inner--active')
					$(this).toggleClass('accordion__inner--active')
					$(this).find('.accordion__content').slideDown()
				}



			})

			$('.accordion__content').click(function (e) {
				e.stopImmediatePropagation()
			})

		},
		initSwiper() {

			new Swiper('.spotlight__swiper', {
				// Optional parameters

				slidesPerView: 1,
				loop: true,
				simulateTouch: false,
				spaceBetween: 0,
				pagination: {
					el: '.spotlight__swiper .swiper-pagination',
					type: 'bullets',
					clickable: true
				},


			});
			new Swiper('.options .swiper', {
				// Optional parameters

				slidesPerView: 1,
				spaceBetween: 0,
				pagination: {
					el: '.options .swiper-pagination',
					type: 'bullets',
					clickable: true
				},


			});
			new Swiper('.different .swiper', {
				// Optional parameters

				slidesPerView: 1.2,
				spaceBetween: 20,
				centeredSlides: true,
				pagination: {
					el: '.different .swiper-pagination',
					type: 'bullets',
					clickable: true
				},

				breakpoints: {


					992: {
						slidesPerView: 4,
						spaceBetween: 20,
						centeredSlides: false
					}
				}



			});

			app.categorySwiper = new Swiper('.category .swiper', {
				// Optional parameters
				centerInsufficientSlides: $(".offer-page-section").length === 1 ? false : true,
				slidesPerView: "auto",
				spaceBetween: 30,
			});


		},

		stickyHeader: function () {
			// Hide Header on on scroll down
			var didScroll;
			var lastScrollTop = 0;
			var delta = 5;
			var navbarHeight = $('.header').outerHeight();




			$(window).scroll(function (event) {

				didScroll = true;
			});

			setInterval(function () {
				if (didScroll) {
					hasScrolled();
					didScroll = false;
				}
			}, 250);

			function hasScrolled() {
				var st = $(window).scrollTop();
				////////console.log(st)

				// Make sure they scroll more than delta
				if (Math.abs(lastScrollTop - st) <= delta)
					return;

				// If they scrolled down and are past the navbar, add class .nav-up.
				// This is necessary so you never see what is "behind" the navbar.
				if (st > lastScrollTop && st > navbarHeight) {
					// Scroll Down
					$('.header').removeClass('header--down').addClass('header--up');

				} else {
					// Scroll Up
					if (st + $(window).height() < $(document).height()) {
						$('.header').removeClass('header--up').addClass('header--down');

					}
				}

				lastScrollTop = st;
			}
		},

		spotlightAnimation: function () {
			if ($('.home-spotlight').length === 0) return false
			//	

			//console.log(app.windowHeight)

			var section1End = 0.66
			var section2End = 0.36

			if (app.windowHeight > 1400) {
				section1End = 0.56
				section2End = 0
			}
			else if (app.windowHeight > 1200) {
				section1End = 0.614
				section2End = 0.16
			}
			else if (app.windowHeight > 1100) {
				section1End = 0.659
				section2End = 0.21
			}
			else if (app.windowHeight > 1000) {
				section1End = 0.66
				section2End = 0.26
			}
			else if (app.windowHeight > 900) {
				section1End = 0.715
				section2End = 0.36
			}
			else if (app.windowHeight > 800) {
				section1End = 0.762
				section2End = 0.41
			}
			else if (app.windowHeight > 700) {
				section1End = 0.66
				section2End = 0.26
			}
			else if (app.windowHeight > 600) {
				section1End = 0.76
				section2End = 0.41
			}
			else if (app.windowHeight > 500) {
				section1End = 0.76
				section2End = 0.41
			}


			//console.log(section1End)
			//console.log(section2End)

			var timeline = new TimelineMax({

			});


			if (!app.isTabletPortrait && window.scrollY < 1000 && !app.isTouch) {
				$(window).scrollTop(0);
				$('html').addClass('overflow-hidden')


			}
			else {
				app.disableSpotlightScroll = true
			}

			$('.spotlight__svg-col').css({
				//	transform: `scale(${$(window).height() / 1000})`
			})







			$('.spotlight__icon').click(function () {

				if (!app.isTouch) {



					if ($(this).hasClass('spotlight__icon--last')) {
						appDetails2Animation()
					}
					else if ($(this).hasClass('spotlight__icon--scrolled')) {
						//app._windowScroll($('.app-details--2').offset().top + 200)
						$(this).addClass('spotlight__icon--last')
						appDetails1Animation()

					}
					else {
						appDetailsAnimation()
					}
				}
				// $(this).removeClass('spotlight__icon--static')
				// $(this).addClass('spotlight__icon--scrolled')
				//app._windowScroll($('.app-details--1').offset().top + 200)

			})




			var spotlight = $('.spotlight');
			var icon = $('.spotlight__icon');
			var appDetails1 = $('.app-details--1');
			var appDetails2 = $('.app-details--2');


			///	var spotlightScrolled = false
			//var appDetails1Scrolled = false


			icon.on('mousewheel', function (event) {
				event.stopImmediatePropagation();
			});



			spotlight.on('mousewheel', function (event) {

				if (!app.disableSpotlightScroll) {
					if (!app.isScrolling) {
						if (event.deltaY === -1) {

							//console.log("spotlight scrolling", app.isScrolling)
							appDetailsAnimation()





							//app.lifeStyleAnimation()
							app.isScrolling = true;

						}


					}
				}




			});

			function appDetailsAnimation() {
				$('.spotlight__icon').css('top', '0')
				app._bodyScroll(appDetails1.offset().top);
				//	if (!spotlightScrolled) {
				timeline.to(".spotlight__icon", {
					duration: 1.2,

					ease: Circ.InOut,
					motionPath: {
						path: "#spotlight__path",
						align: "#spotlight__path",
						start: 0.91,
						end: section1End,
						autoRotate: false,
						alignOrigin: [0.5, 0.52]
					}
				});
				//	spotlightScrolled = true
				//	}

				$('.spotlight__icon').removeClass('spotlight__icon--static')
				$('.spotlight__icon').addClass('spotlight__icon--scrolled')


				app._enableScroll()


			}

			appDetails1.on('mousewheel', function (event) {

				if (!app.disableSpotlightScroll) {
					if (!app.isScrolling) {
						//console.log("appDetails1 scrolling", app.isScrolling)
						if (event.deltaY === -1) {

							appDetails1Animation()


						}
						else {



							app._bodyScroll(0);
							timeline.to(".spotlight__icon", {
								duration: 2,

								ease: Circ.InOut,
								motionPath: {
									path: "#spotlight__path",
									align: "#spotlight__path",
									start: section1End,
									end: 0.91,
									autoRotate: false,
									alignOrigin: [0.5, 0.52]
								}
							});

							$('.spotlight__icon').addClass('spotlight__icon--static')
							$('.spotlight__icon').removeClass('spotlight__icon--scrolled')
							app._enableScroll()


							// timeline.to(".spotlight__icon", {
							// 	duration: 1,

							// 	ease: Linear.easeNone,
							// 	motionPath: {
							// 		path: "#spotlight__path",
							// 		align: "#spotlight__path",
							// 		start: 0.66,
							// 		end: 0.91,
							// 		autoRotate: false,
							// 		alignOrigin: [0.5, 0.5]
							// 	}
							// });

							// $('.spotlight__icon').addClass('spotlight__icon--static')
							// $('.spotlight__icon').removeClass('spotlight__icon--scrolled')
							//app.isScrolling = true;
						}
					}

				}

				app.isScrolling = true;

			});

			function appDetails1Animation() {

				app._bodyScroll(appDetails2.offset().top, false, 500);
				//	$('.global-phone').css({ top: 100 })
				// TweenLite.to('.global-phone', {
				// 	top: (($('.spotlight').height() - app.globalPhoneHeight) / 2),
				// 	duration: 1.5
				// })

				//app.lifeStyleAnimation()
				//	if (!appDetails1Scrolled) {


				timeline.to(".spotlight__icon", {
					duration: 2,

					ease: Circ.InOut,
					motionPath: {
						path: "#spotlight__path",
						align: "#spotlight__path",
						start: section1End,
						end: section2End,
						autoRotate: false,
						alignOrigin: [0.5, 0.52]
					}
				});
				//	appDetails1Scrolled = true

				//	}
				app._enableScroll()


			}
			appDetails2.on('mousewheel', function (event) {


				if (!app.disableSpotlightScroll) {
					if (!app.isScrolling) {
						//console.log("appDetails2 scrolling", app.isScrolling)
						if (event.deltaY === -1) {
							appDetails2Animation()
						}

						else {
							app._bodyScroll(appDetails1.offset().top);
							timeline.to(".spotlight__icon", {
								duration: 2,

								ease: Circ.InOut,
								motionPath: {
									path: "#spotlight__path",
									align: "#spotlight__path",
									start: section2End,
									end: section1End,
									autoRotate: false,
									alignOrigin: [0.5, 0.52]
								}
							});
							app._enableScroll()
							// timeline.to(".spotlight__icon", {
							// 	duration: 1,

							// 	ease: Linear.easeNone,
							// 	motionPath: {
							// 		path: "#spotlight__path",
							// 		align: "#spotlight__path",
							// 		start: 0.91,
							// 		end: 0.66,
							// 		autoRotate: false,
							// 		alignOrigin: [0.5, 0.5]
							// 	}
							// });



						}
					}
				}

				app.isScrolling = true;


			});

			function appDetails2Animation() {
				app._bodyScroll($('.banking').offset().top, true);
				//	$('.global-phone').css({ top: 100 })
				// TweenLite.to('.global-phone', {
				// 	top: (($('.spotlight').height() - app.globalPhoneHeight) / 2),
				// 	duration: 1.5
				// })

				//app.lifeStyleAnimation()
				// app.isScrolling = true;
				app._enableScroll()
				app.disableSpotlightScroll = true;
			}






			// timeline.to(".spotlight__icon", {
			// 	duration: 2,
			// 	ease: Linear.easeNone,
			// 	motionPath: {
			// 		path: "#spotlight__path",
			// 		align: "#spotlight__path",
			// 		start: 0.915,
			// 		end: 0,
			// 		autoRotate: false,
			// 		alignOrigin: [0.5, 0.5]
			// 	}
			// });





			// const items = document.querySelectorAll('.app-details');

			// let observer = new IntersectionObserver(entries => {
			// 	entries.forEach(entry => {

			// 		if (entry.isIntersecting) {

			// 			if (entry.boundingClientRect.top > 0) {



			// 				//console.log(entry.target.classList[1], 'in the view');
			// 				if (entry.target.classList[1] === 'app-details--1') {



			// 					//	app._windowScroll($('.app-details--1').offset().top + 200)
			// 					// timeline.to(".spotlight__icon", {
			// 					// 	duration: 1,

			// 					// 	ease: Linear.easeNone,
			// 					// 	motionPath: {
			// 					// 		path: "#spotlight__path",
			// 					// 		align: "#spotlight__path",
			// 					// 		start: 0.91,
			// 					// 		end: 0.66,
			// 					// 		autoRotate: false,
			// 					// 		alignOrigin: [0.5, 0.5]
			// 					// 	}
			// 					// });



			// 				}
			// 				if (entry.target.classList[1] === 'app-details--2') {



			// 					//	app._windowScroll($('.app-details--2').offset().top + 100)


			// 				}

			// 			}
			// 			///observer.unobserve(entry.target);
			// 		}
			// 		else {
			// 			//console.log(entry.target.classList[1], 'out of view');
			// 		}
			// 	});
			// });

			// items.forEach(item => {
			// 	observer.observe(item);
			// });
		},


		_bodyScroll: function (scroll, allowScroll = false, duration = 300) {
			var body = $("html");
			//console.log("_bodyScroll")
			body.animate({ scrollTop: scroll }, duration, 'swing', function () {

				if (allowScroll) $('html').removeClass('overflow-hidden')
				else $('html').addClass('overflow-hidden')
			});


		},

		_enableScroll: function () {
			//	//console.log("app.isScrolling is right now", app.isScrolling)
			setTimeout(() => {

				app.isScrolling = false;
				////console.log("app.isScrolling set to false", app.isScrolling)
			}, 1000)
		},
		_windowScroll: function (scroll) {

			///window.scrollTo(0, scroll)
			//console.log("scrolling")
			var body = $("html,body");
			body.animate({ scrollTop: scroll }, 0, "linear", function () {
				// alert("Finished animating");
			});
		},
		appDetailsAnimation: function () {

			var items = [

				'.app-details--1 .phone-frame',
				'.app-details--1 .app-details__copy h2',
				'.app-details--1 .app-details__copy p',
				'.app-details--1 .app-details__copy .details-icons__icon',
				'.app-details--1 .btn',
			]


			var timeline = new TimelineMax({
				scrollTrigger: {
					trigger: ".app-details--1",
					//toggleActions: "restart pause resume pause",
					//markers: true,

					start: "top center", // when the top of the trigger hits the top of the viewport


				},
				onComplete: function () {
					//	app.sprite()
				}
			});

			timeline.fromTo('.app-details--1 .app-details__svg', 1, { x: -400, opacity: 1, scale: 0 }, { x: 0, opacity: 1, scale: 1 })
				.fromTo(items, 1, { y: 200, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.2 }, 0.5)

			var items2 = [

				'.app-details--2 .phone-frame',
				'.app-details--2 .app-details__copy h2',
				'.app-details--2 .app-details__copy p',
				'.app-details--2 .app-details__copy ol',
				'.app-details--2 .details-icons__icon',
				'.app-details--2 .btn',
			]


			var timeline = new TimelineMax({
				scrollTrigger: {
					trigger: ".app-details--2",
					//toggleActions: "restart pause resume pause",
					//markers: true,
					start: "top center", // when the top of the trigger hits the top of the viewport


				},
				onComplete: function () {
					//	app.sprite()
				}
			});

			timeline.fromTo('.app-details--2 .app-details__svg', 1, { x: 400, opacity: 1, scale: 0 }, { x: 0, opacity: 1, scale: 1 })
				.fromTo(items2, 1, { y: 200, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.2 }, 0.5)


		},

		bankingAnimation: function () {

			if (!app.isTabletPortrait && $('.banking').length === 1) {
				var disableAnimation = false;
				var grid = $('.banking .mobile-swiper-slide');
				var placeholder = $('.banking__placeholder');
				var container = $('.banking .mobile-swiper').offset().left;

				grid.eq(0).css({
					left: placeholder.eq(0).offset().left - container,
					width: placeholder.eq(0).width()

				})
				grid.eq(1).css({
					left: placeholder.eq(1).offset().left - container,
					width: placeholder.eq(1).width()

				})
				grid.eq(2).css({
					left: placeholder.eq(2).offset().left - container,
					width: placeholder.eq(2).width()

				})



				$('.mobile-swiper-slide').click(function () {

					if (!disableAnimation) {

						disableAnimation = true

						//console.log($(this).data().index)

						if ($(this).attr('data-index') === "0") {


							$(this).css({
								left: placeholder.eq(1).offset().left - container,
								width: placeholder.eq(1).width()
							}).removeClass('mobile-swiper-slide--first').addClass('mobile-swiper-slide--active')
							$('.mobile-swiper-slide[data-index=1]').css({
								left: placeholder.eq(0).offset().left - container,
								width: placeholder.eq(0).width(),

							}).addClass('mobile-swiper-slide--first').removeClass('mobile-swiper-slide--active')

							setTimeout(() => {
								$('.mobile-swiper-slide[data-index=1]').attr('data-index', "0")
								$(this).attr('data-index', "1")
								disableAnimation = false
							}, 500)


						}
						else if ($(this).attr('data-index') === "2") {

							$(this).css({
								left: placeholder.eq(1).offset().left - container,
								width: placeholder.eq(1).width(),

							}).removeClass('mobile-swiper-slide--last').addClass('mobile-swiper-slide--active')
							$('.mobile-swiper-slide[data-index=1]').css({
								left: placeholder.eq(2).offset().left - container,
								width: placeholder.eq(2).width()
							}).addClass('mobile-swiper-slide--last').removeClass('mobile-swiper-slide--active')

							setTimeout(() => {
								$('.mobile-swiper-slide[data-index=1]').attr('data-index', "2")
								$(this).attr('data-index', "1")
								disableAnimation = false
							}, 500)


						}
					}

				})

				var timeline = new TimelineMax({
					scrollTrigger: {
						trigger: ".banking",
						toggleActions: "restart pause resume pause",
						//markers: true,
						start: "top center", // when the top of the trigger hits the top of the viewport


					},
					onComplete: function () {
						//	app.sprite()
					}
				});

				timeline.fromTo('.banking .h1,.banking__grid', 1, { y: 200, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.2, ease: Power2.easeOut })
			}

		},
		featureAnimation: function () {

			var timeline = new TimelineMax({
				scrollTrigger: {
					trigger: ".features",
					toggleActions: "restart pause resume pause",
					//	markers: true,
					start: "top center", // when the top of the trigger hits the top of the viewport


				},
				onComplete: function () {
					//	app.sprite()
				}
			});

			//timeline.fromTo('.features__svg', 1, { y: 200, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.2, ease: Power2.easeOut })


			timeline
				.fromTo("#Path_1-2-features__svg", { drawSVG: "0 0" }, { drawSVG: "0 100%", duration: 2, ease: Linear.easeNone, })
				.fromTo('.features .cards', 1, { y: 200, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.2, ease: Power2.easeOut }, 0.3)



			const items = document.querySelectorAll('.cards');
			//console.log(items)

			let observer = new IntersectionObserver(entries => {
				entries.forEach(entry => {

					if (entry.isIntersecting) {
						//console.log(entry.target.classList[1], 'in view');
						setTimeout(_ => entry.target.classList.add('active'), 400)


					}
					else {
						//console.log(entry.target.classList[1], 'out of view');
					}
				});
			});

			items.forEach(item => {
				observer.observe(item);
			});

		},
		faqAnimation: function () {

			var timeline = new TimelineMax({
				scrollTrigger: {
					trigger: ".faq",
					//	toggleActions: "restart pause resume pause",
					//markers: true,
					//start: "top center", // when the top of the trigger hits the top of the viewport


				},
				onComplete: function () {
					//	app.sprite()
				}
			});

			var items2 = [

				'.faq__media .phone-frame',
				'.faq .h2',
				'.faq .category',
				'.faq .tab-pane .accordion__inner',
				'.faq__cta',

			]

			//timeline.fromTo('.features__svg', 1, { y: 200, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.2, ease: Power2.easeOut })


			timeline.fromTo(items2, 0.5, { y: 100, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.1, ease: Power2.easeOut })

		},
		getStartedAnimation: function () {
			var inView = false
			var timeline = new TimelineMax({
				scrollTrigger: {
					trigger: ".get-started",
					//	toggleActions: "restart pause resume pause",
					//	markers: true,
					//start: "top center", // when the top of the trigger hits the top of the viewport

					onToggle: self => {
						if (self.isActive && !inView) {
							//	//console.log(self.isActive)
							inView = true

							app._animatedSvg('.get-started .foreground-path', '.get-started .animated-circle')
							//app._animatedSvg('.get-started .foreground-path-1', '.get-started .animated-circle-1')

						}
					},
				},
				onComplete: function () {
					//	app.sprite()
				}
			});

			var items2 = [

				'.get-started .h1',
				'.get-started__cont',

			]

			//timeline.fromTo('.features__svg', 1, { y: 200, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.2, ease: Power2.easeOut })





			timeline.fromTo('.get-started__circle', 0.5, { opacity: 1, scale: 0 }, { opacity: 1, scale: 1 })
				.fromTo(items2, 0.5, { y: 200, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.2 }, 0.3)



		},



		_animatedSvg: function (path, circle, duration = 40) {
			gsap.fromTo(path, { drawSVG: "0 0" }, { drawSVG: "0 100%", opacity: 1, duration, ease: Linear.easeNone, })

			gsap.to(circle, {
				duration,
				ease: Linear.easeNone,
				motionPath: {
					path: path,
					align: path,
					start: 0,
					end: 1,
					autoRotate: false,
					alignOrigin: [0.5, 0.5]
				}
			});
		},
		hamburger: function () {
			$('.hamburger__icon').click(function () {

				if ($(this).hasClass('active')) {
					$('.mobile-nav').css('display', 'none')

					gsap.to(".hamburger #Union_11", { duration: 0.3, morphSVG: ".hamburger #Union_11" });
					$(this).removeClass('active')
				}
				else {
					$('.mobile-nav').css('display', 'grid')
					gsap.to(".hamburger #Union_11", { duration: 0.3, morphSVG: ".hamburger #Union_12" });
					$(this).addClass('active')
				}


			})

			$('.mobile-nav .btn,.hamburger a').click(function () {

				$('.mobile-nav').css('display', 'none')

				gsap.to(".hamburger #Union_11", { duration: 0.3, morphSVG: ".hamburger #Union_11" });
				$('.hamburger__icon').removeClass('active')
			});
			//	gsap.to(".hamburger #Union_11", { duration: 1, transform: "translate(-16351.767 -6574.715)" });


		},
		mobileSwiper: function () {

			if (app.isTabletPortrait) {


				$('.mobile-swiper').addClass('swiper')
				$('.mobile-swiper-wrapper').addClass('swiper-wrapper')
				$('.mobile-swiper-slide').addClass('swiper-slide')




				new Swiper('.home-spotlight .mobile-swiper', {
					// Optional parameters

					slidesPerView: 1,
					spaceBetween: 0,
					autoHeight: false,
					pagination: {
						el: '.mobile-swiper .swiper-pagination',
						type: 'bullets',
						clickable: true
					},


				});

				new Swiper('.banking .mobile-swiper', {
					// Optional parameters

					slidesPerView: 1.3,

					spaceBetween: 25,
					//	loop: true,
					centeredSlides: true,


					pagination: {
						el: '.banking .swiper-pagination',
						type: 'bullets',
						clickable: true
					},










				});


			}

		},

		lazyLoad: function () {

			var lazyLoadInstance = new LazyLoad({
				// Your custom settings go here
			});
		},


		_createCookie: function (cname, cvalue, exdays) {
			var d = new Date();
			d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
			var expires = "expires=" + d.toUTCString();
			document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;secure";
		},

		_getCookie(cookieName) {
			var cookieNameEQ = cookieName + "=";
			var ca = document.cookie.split(";");
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == " ") c = c.substring(1, c.length);
				if (c.indexOf(cookieNameEQ) == 0)
					return c.substring(cookieNameEQ.length, c.length);
			}
			return null;
		},


		faq: function () {

			$('#search-faq').on('input', function () {

				////////console.log(filterIt(faqObj, $(this).val()))
				let filteredData = [];
				$('.faq-list__option').remove();
				$('.faq-result').hide()
				filteredData = faqObj.filter(faq => {
					if (faq.Question.toLowerCase().includes($(this).val().toLowerCase())) {

						return faq
					}

				});

				let markup = ''
				for (let index = 0; index < filteredData.length; index++) {
					markup += `<div onClick='app.showFaq("${filteredData[index].Id}")' data-title='${filteredData[index].Title}' class='faq-list__option'>${filteredData[index].Question}</div>`
				}

				//////console.log(markup)

				$('.faq-list').append(markup);
				if (filteredData.length === faqObj.length) {
					$('.faq-list__option').remove();
				}

			});





		},
		showFaq: function (ID) {

			var data = faqObj.find(item => item.Id === ID);

			//////console.log(data.Question)
			//////console.log(data.Answer)


			$('.faq-list__option').remove();
			$('.faq-result').show()
			$('.faq-result .h2').text(data.Question)
			$('.faq-result p').html(data.Answer)
			$(window).scrollTop($('.faq-result').offset().top)

		},


		darkMode: function () {

			let matched = window.matchMedia('(prefers-color-scheme: dark)').matches;

			// if (matched)
			// 	alert('Currently in dark mode');
			// else
			// 	alert('Currently not in dark mode');
			$('.switch').click(function () {
				$(this).toggleClass('switch--active')
				$('html').toggleClass('dark-mode')

				if ($(this).hasClass('switch--active')) {
					app._createCookie("dark-mode", "on", 360);
					addCss()
				}
				else {
					app._createCookie("dark-mode", "off", 360);
					$('#dark-mode-css').remove()
					$('.options__bg ').each(function () {
						//$(this).attr("data-oldbg", $(this).attr("style").split('background:')[1])
						////console.log($(this).attr("style").split('background:')[1])
						$(this).css('background-color', $(this).attr('data-oldbg'))
					})
				}
			});

			if (matched) {
				if (app._getCookie("dark-mode") !== 'off') {
					$('.switch').addClass('switch--active')
					$('html').addClass('dark-mode')
					addCss()

				}
			}

			function addCss() {
				var head = document.head;
				var link = document.createElement("link");

				link.type = "text/css";
				link.id = "dark-mode-css";
				link.rel = "stylesheet";
				link.href = '../assets/css/darkmode.css?v=696';

				head.appendChild(link);

				$('.options__bg ').each(function () {
					$(this).attr("data-oldbg", $(this).attr("style").split('background:')[1])
					////console.log($(this).attr("style").split('background:')[1])
					$(this).css('background-color', $(this).attr('data-darkbg'))
				})
			}



		},
		toggleBanner: function () {
			$('.toggle-banner__arrow').on("click", function () {
				$('.toggle-banner__container').slideDown('slow');
				$('.toggle-banner').addClass('opened')
			});
			$('.toggle-banner__close').on("click", function () {
				$('.toggle-banner__container').slideUp('slow');
				$('.toggle-banner').removeClass('opened')
			});

		},

		listingVideoOverlay() {
			var videoSelctor = $('.js-video-overlay'),
				closeBtn = $('.js-close-btn');

			videoSelctor.on('click', function () {
				var overlay = document.getElementById('overlay');
				var modal = document.getElementById('modal');

				overlay.style.display = 'block';
				modal.style.display = 'block';

				overlay.offsetHeight;
				modal.offsetHeight;

				overlay.style.opacity = '1';
				modal.style.opacity = '1';
			});

			closeBtn.on('click', function () {
				var overlay = document.getElementById('overlay');
				var modal = document.getElementById('modal');

				overlay.style.opacity = '0';
				modal.style.opacity = '0';

				setTimeout(function () {
					overlay.style.display = 'none';
					modal.style.display = 'none';
				}, 300);
			})
		},
		sectionFilter: function () {

			$('.section-filter a').click(function (e) {
				e.preventDefault()

				$('.section-filter .filter-tabs-items').removeClass('active')

				$(this).parents('.filter-tabs-items').addClass('active')
				$('.section-filter-items').removeClass('app-details--right')
				if ($(this).attr('href') === '#All') {
					$('.section-filter-items').show()
					var sections = $(".section-filter-items");
					for (var i = 0; i < sections.length; i++) {
						if (i % 2 != 0 && i != 0) {
							$(".section-filter-items")[i].classList.add('app-details--right')
						}

					}

				}
				else {
					$('.section-filter-items').hide()
					// $($(this).attr('href')).show()

					var sections = $(".section-filter-items");
					var isright = false;

					for (var i = 0; i < sections.length; i++) {
						var idsarray = sections[i].dataset.category.split(' ');
						if (idsarray.includes($(this).attr('href'))) {
							console.log('idsarray ==========>', idsarray)
							console.log('isright ==========>', isright)
							console.log('items ==========>', $(".section-filter-items")[i])

							$(".section-filter-items")[i].style.display = 'block'
							if (isright) {
								$(".section-filter-items")[i].classList.add('app-details--right')
								isright = false;
							}
							else {
								isright = true
								$($('.section-filter-items')[i]).find('.col-12.col-lg-5.offset-lg-1').removeClass('offset-lg-1');
								$($('.section-filter-items')[i]).find('.col-12.col-lg-6.app-details__col').addClass('offset-lg-1');
							}


						}
					}



				}

			})

		},


		init() {





			app.detectCulture();
			app.detectDevice();
			app.getMobileOperatingSystem();
			app.resizeListner();
			app.addEventListner();
			//	app.flatPicker();

			app.accordion()
			app.faq()
			app.initSwiper();

			app.stickyHeader();
			app.appDetailsAnimation();
			app.spotlightAnimation();
			app.bankingAnimation();
			app.featureAnimation();
			app.faqAnimation();
			app.getStartedAnimation();
			app.hamburger();
			app.mobileSwiper()
			app.lazyLoad()
			app.tabs()
			app.sectionFilter()
			app.toggleBanner();
			app.listingVideoOverlay();
			// app.benefitsAnimation()
			app._animatedSvg('.benefit-intro .foreground-path', '.benefit-intro .animated-circle', 25)
			app._animatedSvg('.inner-banner .foreground-path', '.inner-banner .animated-circle', 25)




			if (app.isTabletPortrait) {
				$('.cards').addClass('active')
				app.darkMode()
			}


			app._animatedSvg('.content .foreground-path', '.content .animated-circle')

			// var item = document.getElementById('Union_2');
			// gsap.to(item, { morphSVG: "#Union_10" }, "+=1")





		},
	}
	window.app = app;

}(jQuery));

$(document).ready(() => {
	window.app.init();
});